import { Typography, Grid, Box } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IdCardImg from '../../../../Assets/IdcardImg.png';
import KenButton from '../../../../GlobalComponents/KenButton';
import { useStyles } from '../../style';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { lg: 350, xl: 350 },
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  p: 2,
  overflowY: 'auto',
};

const IdCard = (props: any) => {
  const classes = useStyles();
  return (
    <div>
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <Typography sx={{ fontSize: '13px', fontWeight: '500' }}>ID Card</Typography>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} style={{ display: 'flex', justifyContent: 'end', cursor: 'pointer' }}>
            <CloseIcon onClick={props.handleClose} sx={{ fontSize: '15px' }} />
          </Grid>
        </Grid>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Box sx={{ height: '25vh' }}>
          <img src={IdCardImg} height="100%" width="100%" />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              mt: 2,
              borderRadius: '8px',
              fontweight: '500',
              backgroundColor: 'none',
              '&:hover': {
                backgroundColor: 'transparent',
              },
              color: 'black',
            }}
            onClick={props.handleClose}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#373A45' }}>Cancel</Typography>
          </KenButton>
          <KenButton
            variant="contained"
            className={classes.button}
            onClick={props.handleClose}
            style={{
              marginTop: 15,
              borderRadius: '7px',
              boxShadow: 'none',
              '&:hover': {
                boxShadow: 'none',
              },
            }}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>Download</Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default IdCard;
